import { defineMessages } from '@jutro/locale';

export default defineMessages({
    billingHistory: {
        id: 'ml.gateway.MLPolicyBillingHistoryComponent.Billing History',
        defaultMessage: 'Billing History'
    },
    transactionsWillNotDisplay: {
        id: 'ml.gateway.MLPolicyBillingHistoryComponent.Transactions made within the past 24 hours will not display',
        defaultMessage: 'Transactions made within the past 24 hours will not display.'
    },
    collapse: {
        id: 'ml.gateway.MLPolicyBillingHistoryComponent.COLLAPSE',
        defaultMessage: 'COLLAPSE'
    },
    viewAll: {
        id: 'ml.gateway.MLPolicyBillingHistoryComponent.VIEW ALL',
        defaultMessage: 'VIEW ALL'
    }
});